// import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import EnotePrivacy from './apps/enote/enote-privacy/enote-privacy';
import TodoPrivacy from './apps/todo/todo-privacy/todo-privacy';
import TodoTerms from './apps/todo/todo-terms/todo-terms';
import VipadPrivacy from './apps/vipad/vipad-privacy/vipad-privacy';
import VipadTerms from './apps/vipad/vipad-terms/vipad-terms';
import PhiboPrivacy from './apps/phibo/phibo-privacy/phibo-privacy';
import PhiboTerms from './apps/phibo/phibo-terms/phibo-terms';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="enote/privacy" element={<EnotePrivacy />} />
        <Route path="todo/privacy" element={<TodoPrivacy />} />
        <Route path="todo/terms" element={<TodoTerms />} />
        <Route path="vipad/privacy" element={<VipadPrivacy />} />
        <Route path="vipad/terms" element={<VipadTerms />} />
        <Route path="phibo/privacy" element={<PhiboPrivacy />} />
        <Route path="phibo/terms" element={<PhiboTerms/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
